import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/compat/firestore';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { Staff } from '../models/staff';
import { Observable } from 'rxjs';
import { SnackBarIconService } from '../shared/snack-bar-icon/snack-bar-icon.service';

@Injectable({
  providedIn: 'root'
})
export class StaffService {

  public objectImage: any = null; // store input file for avatar
  public storedImage: any; // store url image for local preview

  private itemDoc: AngularFirestoreDocument<Staff>;
  private item: Observable<Staff>;

  constructor(private db: AngularFirestore,
    private fs: AngularFireStorage,
    private ff: AngularFireFunctions,
    private snackBar: SnackBarIconService) { }

  select() {
        return this.db.collection<Staff>('sbccv_staffs', ref => ref.orderBy('name', 'asc')).snapshotChanges();            
  }

  selectById(id) {
    this.itemDoc = this.db.doc<Staff>('sbccv_staffs/' + id);
    this.item = this.itemDoc.valueChanges();
    return this.item;
  }

  insert(entity: Staff) {
    delete entity.id;
    return this.db.collection('sbccv_staffs').add(Object.assign({}, entity));
  }

  update(entity: Staff) {
    let id = entity.id;
    delete entity.id;
    return this.db.collection('sbccv_staffs').doc(id).set(Object.assign({}, entity));
  }

  delete(entity_id: any) {
    return this.db.collection('sbccv_staffs').doc(entity_id).delete();
  }

  makeMsgError(errorsCode) {
    let msgError: string
    switch (errorsCode) {
      case "auth/email-already-exists":
        msgError = "Este email já está em uso"
        break;
    }
    return msgError
  }

}

